export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#106795',
    light: '#E7F9FF',
    border: '#B7C0D8'
  },
  secondary: {
    main: '#006EBB',
    contrastText: '#0A5285',
    light: '#D9EDF7',
    border: '#B7C0C8'
  },
  text: {
    primary: '#0E2E3B',
    secondary: '#0A0A0A',
    tertiary: '#4A5462',
    alternate: '#23B0E7',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
    link: "#0283C4"
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    fill:'#F9F6F1',
    fill2:'#A3DFF0',
    planCard: '#C2EAFF',
    main: '#FFFFFF',
    paper: '#FFF',
    default: '#FFF',
    header: '#0D2145',
    footer: '#161F25',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: '#2BAAE1',
    tableSubhead: '##F0F9FF',
    tableBorder: '#7D808880',
    tableAlternate: '#FFFFFF',
    alternate: '#E5EAF4',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#E75204',
    secondary: '#F8D859',
    light: '#F8FBFE',
    secondaryLight: 'rgba(238, 246, 250, 0.6)',
    primaryLight: '#D9EDF7',
    ribbon: '#bbe6fb',
    border: '#50C8ED',
  },
  surface: {
    benefits: '#F9FAFC',
    staticFooter: 'rgba(215, 235, 249, 0.3)'
  },
  verticalBar: {
    used: '#106795',
    unused: '#E7F9FF',
    unlimited: '#C0C0C0',
  }
};
